import React, {useRef, useState} from 'react'
import {connect} from "react-redux";

import Dcc from "../power/dcc";

import Editbar from "./editor/editbar";
import AccBox from "./planitems/bmbox/AccBox";
import BmBox from "./planitems/bmbox/BmBox";
import Lccontainer from "../control/lccontainer";
import ModuleBox from "./ModuleBox";

const Topbar = ({scenario}) => {
    return(
        <div
        style={{
            position: 'fixed',
            top: '0',
            left: '0',
            zIndex: '2',
            height: '32px',
            width: window.innerWidth-10,
            overflow: 'hidden',
            margin: '5px',
        }}
        >
            <div>
                <Editbar scenario={scenario}/>
            </div>

            <div
                style={{
                    position: 'fixed',
                    right: 5,
                }}
            >
                <ModuleBox scenario={scenario}/>
                <Lccontainer key={'lc_container'} id={'lc_container'}/>
                <BmBox key={'bm_box'} id={'bm_box'}/>
                <AccBox key={'acc_box'} id={'acc_box'}/>
                <Dcc/>
            </div>
        </div>
    );
}

function mapStateToProps(state, ownProps) {
    return state;
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Topbar)